import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Coverage } from "@/components/site/Coverage";
import { Partners } from "@/components/site/Partners";
import { PlansSection } from "@/components/site/PlansSection";
import { Section } from "@/components/site/Section";
import { PromoPopup } from "@/components/site/PromoPopup";
import { Reveal, RevealStagger } from "@/components/site/Reveal";
import { useSiteSection } from "@/hooks/useSiteContent";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Contato Internet — Internet fibra óptica com conexão de verdade" },
      {
        name: "description",
        content:
          "Planos de fibra óptica de 500 Mega a 1 Giga com Wi-Fi incluso, +200 canais de TV, instalação grátis e suporte local.",
      },
      { property: "og:title", content: "Contato Internet — Conexão de verdade" },
      {
        property: "og:description",
        content:
          "Planos de fibra óptica de 500 Mega a 1 Giga com Wi-Fi incluso, instalação grátis e suporte local.",
      },
    ],
  }),
  component: Index,
});

function Index() {
  const testimonials = useSiteSection("testimonials");
  const items = (testimonials.items ?? []).filter((t) => t.name);

  return (
    <>
      <Hero />

      <Reveal variant="fade-up" delay={100} data-track-section="servicos">
        <Services />
      </Reveal>

      <Reveal variant="fade-in" delay={100} data-track-section="parceiros">
        <Partners />
      </Reveal>

      <Reveal variant="slide-left" delay={100} data-track-section="cobertura">
        <Coverage />
      </Reveal>

      <Reveal variant="fade-up" delay={100} data-track-section="planos">
        <PlansSection expandable />
      </Reveal>

      {items.length > 0 && (
        <Section eyebrow={testimonials.eyebrow} title={testimonials.title} track="depoimentos">
          <RevealStagger className="grid gap-6 md:grid-cols-2" staggerDelay={120}>
            {items.map((t) => (
              <figure key={t.name} className="rounded-3xl border border-border bg-card p-6 sm:p-8">
                <blockquote className="text-base leading-relaxed text-foreground sm:text-lg">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-6">
                  <span className="block font-extrabold">{t.name}</span>
                  <span className="text-sm text-muted-foreground">{t.role}</span>
                </figcaption>
              </figure>
            ))}
          </RevealStagger>
        </Section>
      )}

      <PromoPopup />
    </>
  );
}
